import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Filler,
} from 'chart.js';
import { Paper, Typography, Box, CircularProgress, Alert } from '@mui/material';
import { getStats } from '../api'; // Import getStats from api.js

ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Filler);

const Chart = () => {
  const [chartData, setChartData] = useState({
    labels: ['Users', 'Insurances', 'Loans', 'Rents', 'Bills'],
    datasets: [
      {
        label: 'Counts',
        data: [0, 0, 0, 0, 0], // Initial placeholder data
        fill: true,
        borderColor: '#e0b256',
        backgroundColor: 'rgba(224, 178, 86, 0.15)',
        tension: 0.4,
        pointBackgroundColor: '#e0b256',
        pointRadius: 5,
      },
    ],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const stats = await getStats();
        setChartData({
          labels: ['Users', 'Insurances', 'Loans', 'Rents', 'Bills'],
          datasets: [
            {
              label: 'Counts',
              data: [
                stats.total_users,
                stats.total_insurances,
                stats.total_loans,
                stats.total_rents,
                stats.total_bills,
              ],
              fill: true,
              borderColor: '#e0b256',
              backgroundColor: 'rgba(224, 178, 86, 0.15)',
              tension: 0.4,
              pointBackgroundColor: '#e0b256',
              pointRadius: 5,
            },
          ],
        });
        setError(null);
      } catch (err) {
        setError(err.message || 'Failed to fetch statistics');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: '#fff',
        titleColor: '#333',
        bodyColor: '#555',
        borderColor: '#e0b256',
        borderWidth: 1,
      },
      title: {
        display: true,
        text: 'Dashboard Statistics',
        font: { size: 16, weight: '600' },
        color: '#fff',
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          font: { size: 12 },
          color: '#ccc',
        },
        title: {
          display: true,
          text: 'Categories',
          font: { size: 14 },
          color: '#ccc',
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          font: { size: 12 },
          color: '#ccc',
        },
        title: {
          display: true,
          text: 'Count',
          font: { size: 14 },
          color: '#ccc',
        },
      },
    },
  };

  return (
    <Paper
      elevation={0}
  sx={{
    p: 5,
    borderRadius: 10,
    height: 500,
    width: '150%',
    maxWidth: '1600px',
        boxShadow: 6,
        transition: '0.3s',
        '&:hover': {
          boxShadow: 10,
          transform: 'scale(1.01)',
        },
        backgroundColor: '#1f1f1fff',
      }}
    >
      <Box mb={2}>
        <Typography variant="h6" fontWeight={600} color="#fff">
          Dashboard Statistics
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Overview of user and financial metrics
        </Typography>
      </Box>
      <Box height="300px">
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <CircularProgress color="inherit" />
          </Box>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <Line data={chartData} options={options} />
        )}
      </Box>
    </Paper>
  );
};

export default Chart;